import { Fragment } from 'react';

import { useEffectOnce } from '@genially/ui/build/hooks/useEffectOnce';

import { PlaySpinner } from '../../../../../../shared/application/components/PlaySpinner/PlaySpinner';
import { useNavigation } from '../../../../../../shared/application/hooks/useNavigation';
import { RouteNames } from '../../../../../domain/RouteNames';
import { usePlayersLimits } from '../../components/PlayersLimitsProvider/PlayersLimitsProvider.context';

interface CheckHasSessionsAvailableProps {
  children: React.ReactNode;
}

export const CheckMonthlyPlayersLimitNotReached = ({
  children,
}: CheckHasSessionsAvailableProps) => {
  const { limitPerMonth } = usePlayersLimits();

  const { navigate } = useNavigation();

  useEffectOnce(() => {
    if (limitPerMonth.isLimitReached) {
      navigate({ to: RouteNames.PlayersLimitReached });
    }
  });

  if (limitPerMonth.isLimitReached) {
    return <PlaySpinner />;
  }

  return <Fragment>{children}</Fragment>;
};
